import { render, staticRenderFns } from "./member-audit-manag.vue?vue&type=template&id=6c047620&"
import script from "./member-audit-manag.vue?vue&type=script&lang=js&"
export * from "./member-audit-manag.vue?vue&type=script&lang=js&"
import style0 from "./member-audit-manag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports